import * as React from 'react';
import { useTheme } from 'styled-components';

const NavAlertIcon = ({ isSelected }: { isSelected: boolean }) => {
	const theme = useTheme();
	const iconColor = isSelected ? theme.primaryBackground : 'white';

	return (
		<svg height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.1113 18.5C10.8359 18.8054 10.4394 19 10 19C9.56055 19 9.16408 18.8054 8.88867 18.5H11.1113Z"
				stroke={iconColor}
				strokeWidth="2"
			/>
			<path
				d="M10 1C12.9477 1 15.25 3.30228 15.25 6.25V10C15.25 12.0471 16.5074 13.5464 17.418 14.457L17.7109 14.75H18.75C18.8978 14.75 18.9432 14.7948 18.9492 14.8008C18.9552 14.8068 19 14.8522 19 15C19 15.1478 18.9552 15.1932 18.9492 15.1992C18.9432 15.2052 18.8978 15.25 18.75 15.25H1.25C1.10225 15.25 1.05675 15.2052 1.05078 15.1992C1.04481 15.1932 1 15.1478 1 15C1 14.8522 1.04481 14.8068 1.05078 14.8008C1.05675 14.7948 1.10225 14.75 1.25 14.75H2.28906L2.58203 14.457C3.49264 13.5464 4.75 12.0471 4.75 10V6.25C4.75 3.30228 7.05228 1 10 1Z"
				stroke={iconColor}
				strokeWidth="2"
			/>
		</svg>
	);
};

export default NavAlertIcon;
